export enum ForWho {
    Me = "Me",
    SomeOneElse = "Someone else",
    Company = "Company"
}